module.exports = {
    digitalStageTrackingOptions: [
        "-None-",
        "Pending Up-Selling/Cross-Selling",
        "L - Qualification",
        "L - Needs Analysis",
        "L - Value Proposition",
        "L - Identify Decision Makers",
        "L - Presentation",
        "L - Application",
        "L - Signature",
        "L - Underwriting",
        "L - Medical",
        "L - APS/MIB",
        "L - Decision ( Approved/Denial/PostPone/Rated)",
        "L - Accepted/Re-Apply/Change Premium",
        "L - Delivery",
        "In - Presentation",
        "In - Application",
        "In - Documents Pending(Sin Number/Void Chq,/Etc.)",
        "In - Signature",
        "T - Lead stage in Leads- Let's Go Ahead and do the policy",
        "T - Info shared (Travelers)",
        "T - Credit Card info(Pending/Provided)",
        "T - Wait till the specific Date",
        "T - Policy Done",
      ],
      statusOptions:[
        "-None-",
        "Active",
        "Inactive",
        "Attempted to Contact",
        "Contact in Future",
        "Pre Qualified",
        "Discovery Call",
        "Contacted",
        "Not Interested",
        "Discussions",
        "Quoted",
        "Appointment",
        "Application Go Ahead Received - Life",
        "Application Go Ahead Received - Travel / Supervisa",
      ],
      insuranceleadSourceOptions:[
        "-None-",
        "Radio",
        "Trade Show",
        "Vendor Partner Seminar",
        "Referral",
        "Internal Seminar",
        "Google",
        "Social Media",
        "Cold Call",
        "Email Campaign",
        "Website",
        "Facebook",
        "Twitter",
        "Canadian LIC Website",
        "Harpreet Puri Website",
        "Linked In",
        "SVIC Website (Super Visa)",
        "Walk Ins",
        "Old Database",
        "Google AdWords",
      ],
      advisorModuleNameOptions:[
        "-None-",
        "Jonny Advisor",
        "test",
        "Jonny Saini",
        "fghjns",
        "test2345",
        "Preeti hooda",
        "Cheshta Sharma",
      ],
      socialMediaInformationOptions:["-None-", "Yes", "No"],
      parentClientOptions:[
        "-None-",
        "Shashi Nidhi",
        "Shashi saini",
        "test test",
        "test test",
        "Preeti Hooda",
        "Christopher Maclead (Sample)",
        "Kris Marrier (Sample)",
      ],
      preferredContactMethodOptions:[
        "-None-",
        "Email Cell Phone Home Phone",
        "Email",
        "Cell Phone",
        "Home Phone",
        "Work Phone",
        "Text",
        "Email, Cell Phone, WhatsApp",
      ],
      availabilityOptions:[
        "-None-",
        "Weekdays - Morning",
        "Weekdays - Afternoon",
        "Weekdays - Evening",
        "Weekends - Morning",
        "Weekends - Afternoon",
        "Weekends - Evening",
        "Weekdays - Morning, Afternoon, Evening",
        "Weekends - Morning, Afternoon, Evening",
        "Weekdays - Weekends - Morning",
        "Weekdays - Weekends - Afternoon",
        "Weekdays - Weekends - Evening",
      ],
    
    choice:["-None-", "Unknown", "Yes", "No"],
    priorityOptions:[
        "-None-",
        "Unknown",
        "Low",
        "Moderate",
        "High",
        "Expert",
      ],
      optionsArray: ["-None-","available", "unavailable", "none"],
      serviceAvailedOptions:[
        "-None-",
        "Life Insurance",
        "Living Benefits",
        "Health & Dental Insurance",
        "Travel Insurance",
        "Investments",
        "Combination or Hybrid Insurance",
        "Loan Protection",
        "Group Insurance",
        "Business Insurance",
      ],
      lifeInsuranceOptions:[
        "-None-",
        "Term Life",
        "Universal Life",
        "Permanent Universal Life",
        "Whole Life",
        "Participating Whole Life",
        "Non Medical",
        "Permanent / T100",
      ],
      lifeBenefitsOptions:[
        "-None-",
        "Critical Illness Disability - Accidental",
        "Disability - Accidental",
        "Disability - Illness",
        "Hospital Expenses",
        "Accidental Benefits",
        "Critical Illness",
      ],
      loanProtectionOptions:[
        "-None-",
        "Living Benefits- Critical, Disability",
        "Travel Insurance- SuperVisa, Visitor, Travel",
        "Investments- RESP, RRSP, TFSA",
        "Health & Dental Insurance",
        ],
        travelInsuranceOptions:[
          "-None-",
            "Travel",
            "Super Visa",
            "Visitor",
            "International Student",
          ],
          
          processStageOptions:[
            "-None-",
            "Attempted to Contact",
            "Discussions",
            "Quoted",
            "Appointment",
            "Contact in Future",
            "Application Go Ahead Received - Life",
            "Application Go Ahead Received - Travel / Supervisa",
            "Application Go Ahead - RESP, RRSP, TFSA, SEG",
          ],
          relationShipStatusOptions:[
            "-None-",
            "Single",
            "Married",
            "Divorced",
            "Common Law",
            "Widow",
            "Widower",
          ],
          religionOptions:[
            "-None-",
            "Buddhism",
            "Unknow",
            "Christianity",
            "Hinduism",
            "Islam",
            "Judaism",
            "Sikhism",
          ],
          celebratedFestivalsOptions:[
            "-None-",
            "Canada Day",
            "New Year",
            "Family Day",
            "Victoria Day",
            "Father's Day",
            "Mother's Day",
          ],
          festivals:[
            "-None-",
            "Eid-ul-Fitr",
            "Bakr-Eid",
            "Holi",
            "Dussehra",
            "Diwali",
            "Raksha Bandhan",
            "Guru Nanak Jayanti",
            "Guru Gobind Singh Jayanti",
            "Guru Granth Sahib Prakash Divas",
            "Passover",
            "Victoria Day",
            "Family Day",
            "Mother's Day",
            "Thanksgiving",
            "Christmas",
            "New Year",
            "Lohri",
            "Vaisakhi",
            "Father's Day",
          ],
          referredByOtions:[
            " -None-",
            "Social Media",
            "Radio",
            "Google",
            "Advisor",
            "External Referral ",
          ],
      
          advisorStatusOptions:["-None-","active", "inactive", "suspended", "suspended"],
          organizationLevelOptions:["-None-", "A1", "L1", "L2", "L3" ],
          teamNameOptions :["-None-","Team 1", "Team 2", "Team 3"],
          employmentTypeOptions:["-None-", "Single", "Team"],
          hireLevelOptions:["-None-","A1", "L1", "L2", "L3"],
          hireTypeOptions:["-None-","Single", "Team"],
          bonusLevelInfo:["-None-", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"],
          fycPercentageOptions:["-None-", "110"],
          supervisaPayoutOptions:["-None-", "1", "2", "3", "4"],
          premiumPercentageOptions:["-None-", "25"],
          preferredContactMethod:["-None-", "Cell Phone", "Home Phone", "Work Phone", "Text", "Email"],
          preferredContactTimeOptions:["-None-", "Weekdays - Morning", "Weekdays - Afternoon", "Weekdays - Evening", "Weekends - Morning", "Weekends - Afternoon", "Weekends - Evening", "Weekdays- Weekends- Morning", "Weekdays- Weekends- Evening", "Weekdays- Weekends- Afternoon", "Weekdays- Morning, Afternoon, Evening", "Weekends- Morning, Afternoon, Evening"],
          isthisaReassignmentOptions:["-None-", "Yes", "No"],
          loanProtectionOption:[ "-None-","Rent Insurance", "Mortgage Protection", "Loan Protection", "Credit Protection"],
          referralSourceOptions:[ "-None-", "Client", "Other than client"],
          socialMediaInfoOption:["-None-", "Available", "Unavailable"],
          groupInsuranceOption:["-None-", "Group Life", "Group Disability", "Group Accidental Benefits", "Group Health & Dental", "Group Travel", "Group Eye Care", "Group Critical Illness", "Group Flexible Plan"],
          referredByOptions:["-None-","Social Media", "Radio", "Google", "Advisor", "External Referral"],
          citizenshipStatusOptions:["-None-", "Canadian Citizenship", "PR", "Work Permit", "Student"],
          understandingOfInsuranceOptions:["-None-", "Yes", "No"],
          existingInsurancePolicyOptions:["-None-", "Expert", "High", "Low"] ,
          serviceRequestedOptions:[
            "-None-",
            "Status",
            "Life Insurance",
            "Living Benefits",
            "Health & Dental Insurance",
            "Travel Insurance",
            "Investments",
            "Combination or Hybrid Insurance",
            "Loan Protection",
            "Group Insurance",
            "Super Visa Insurance",
            "Business Insurance"
          ],
          doYouOwnHomeInCanadaOptions:["-None-", "Yes", "No"],
          doYouHaveLifeInsuranceOptions:["-None-", "Yes", "No"],
          productCataegoryOptions:["-None-", "Life", "Living Benefits", "Travel", "Health & Dental"],
          livingBenefitsCategoryOptions:["-None-", "Critical Illness", "Disability - Accidental", "Disability - Illness", "Hospital Expenses", "Accidental Benefits"],
          genderOptions:["-None-", "Male", "Female"],
          genderpredictionOptions:["-None-","-Unkown-", "Male", "Female"],
          emailIsValidOptions:["-None-", "Yes", "No"],
          oldLeadDatabaseOptions:["-None-", "Yes", "No"],
          investmentOptions:["-None-", "Business Insurance", "Mutal Funds", "TFSA", "Seg Funds", "Annuities", "RRSP", "RRSP Loans", "RESP", "GIC", "Savings Account", "Pension Plan", "RIF", "GIA"],
          yearOptions:["-None-","2020", "2021", "2022", "2023", "2024", "2025"],











          
          










}